import { textElementDimensions } from "@modules/datasheets/components/editor/editor.constants";
import { IDatasheetEditorElement } from "../../datasheet.types";
import { DatasheetElement, DatasheetElementId } from "@modules/datasheets/types/datasheet-element";
import { useDatasheetElementController } from "../../hooks/datasheet-element.controller";
import { DatasheetTextComponentGetDto } from "@common/dto/datasheet/text-component/get-dto";
import React from "react";

export type TextElementProps = IDatasheetEditorElement<DatasheetTextComponentGetDto> & {
  onTextChange: (
    datasheetElementId: DatasheetElementId,
    data: Partial<DatasheetElement<DatasheetTextComponentGetDto>>
  ) => void;
};

export const useTextElementController = (props: TextElementProps) => {
  const {
    datasheetElement,
    containerRef,
    isSelected,
    onSelect,
    onTextChange,
    onCoordinatesChange,
    datasheetGridSettings,
    onResize,
    multipleElementsSelected,
    resizeHandlerStrategy,
    isTabOrderSettingActive,
  } = props;

  const datasheetElementController = useDatasheetElementController({
    isTabOrderSettingActive,
    resizeHandlerStrategy,
    datasheetElement,
    containerRef: containerRef,
    minWidth: textElementDimensions.width,
    minHeight: textElementDimensions.height,
    isSelected,
    onSelect,
    onCoordinatesChange,
    onResize,
    datasheetGridSettings,
    multipleElementsSelected,
  });

  const handleTextChange = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onTextChange(datasheetElement.id, {
        ...datasheetElement,
        original: {
          ...datasheetElement.original,
          text: e.target.value,
        },
      });
    },
    [datasheetElement]
  );

  return {
    ...datasheetElementController,
    handleTextChange,
  };
};
